import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { localStg } from '@/utils/storage';
import { SetupStoreId } from '@/enum';
import { getVersion } from './shared';

export type VersionType = 'BASE' | 'NON-BASE';

export const useVersionStore = defineStore(SetupStoreId.Version, () => {
  const version = ref<VersionType>(getVersion());
  // 添加用户ID状态
  const userId = ref<string>(localStg.get('userId') || '');

  // Whether it's base version
  const isBaseVersion = computed(() => version.value === 'BASE');

  // 获取用户ID
  const getUserId = computed(() => userId.value);

  // Set version
  function setVersion(versionType: VersionType) {
    version.value = versionType;
    localStg.set('version', versionType);
  }

  // 设置用户ID
  function setUserId(id: string) {
    userId.value = id;
    localStg.set('userId', id);
  }

  // Reset version store
  function resetStore() {
    const versionStore = useVersionStore();
    localStg.remove('version');
    localStg.remove('userId');
    versionStore.$reset();
  }

  // 判断数据是否不属于当前租户
  function isDifferentTenant(rowTenant: string) {
    if (import.meta.env.DEV) {
      return false;
    }
    if (!rowTenant) return false;
    const tenantId = rowTenant.split('@')[1];
    if(!tenantId) return false
    return tenantId !== userId.value;
  }

  return {
    version,
    userId,
    isBaseVersion,
    getUserId,
    setVersion,
    setUserId,
    resetStore,
    isDifferentTenant
  };
});
